module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("THE STRUGGLE FOR EUROPE "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Chester Wilmot")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPRINT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCIETY")]), _vm._v(", 1954")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("THE FATAL DECISIONS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEGRFIED")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTPHAL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2012")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("ROMMEL IN HIS OWN WORDS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Editor Dr John Pimlott")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REENHILL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" 1994")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("WAFFEN-SS COMMANDERS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Mark C Yerger")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHIFFER")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILITARY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")]), _vm._v(" 1997 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VOLUMES")]), _vm._v(" 1 and 2")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("Battleground MALTA "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Paul Williams")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2009")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("SURRENDER OF SINGAPORE: THREE YEARS OF HELL "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Stephen Wynn")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2017")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("THE AXIS OCCUPATION OF EUROPE "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Winston & Gail Ramsey")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE")]), _vm._v(", 2018")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("THE BLITZ T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" & N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLUME")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Winston G Ramsey")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("(A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGAZINE")]), _vm._v(") 2017")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("THE DESERT WAR THEN & NOW "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Jean Paul Pallud")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE")]), _vm._v(", 2012")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("SPECIAL FORCES in the DESERT WAR 1940-1943 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Brigadier H W Wynter")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLIC")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECORD")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFICE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORIES")]), _vm._v(", 2001")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("EARLY US NAVY CARRIER RAIDS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by David Lee Russell")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLAND")]), _vm._v(" & C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPANY")]), _vm._v(", I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NC")]), _vm._v("., P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHERS")]), _vm._v(" 2019")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("THE BOMBER COMMAND WAR DIARIES 1939 - 1945")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Martin Middlebrook and Chris Everitt")]), _vm._v(", 2014")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("FAMOUS BOMBERS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF THE")]), _vm._v(" SECOND WORLD WAR "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by William Green")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACDONALD")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANE")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHERS")]), _vm._v(" 1979")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("FAMOUS FIGHTERS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF THE")]), _vm._v(" SECOND WORLD WAR "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by William Green")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACDONALD AND")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANE")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHERS ")]), _vm._v("1977")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("FIGHTER SQUADRONS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF THE")]), _vm._v(" RAF "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by John D R Rawlings")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACDONALD")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(" 1969")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("THE GREAT PATRIOTIC WAR "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Peter G Tsouras")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REENHILL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(" 1992")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("U-BOATS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Antony Preston")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RMS")]), _vm._v(" & A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RMOUR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(" 1978")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("PICTORIAL HISTORY "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF THE")]), _vm._v(" WAR (F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST YEAR SEVEN VOLUMES")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Edited by Walter Hutchinson,")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTUE")]), _vm._v(" & C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPANY")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("THE SECOND GREAT WAR (N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INE VOLUMES")]), _vm._v(") "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Edited by Sir John Hammerton")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVERLEY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPANY")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("THE WAR IN PICTURES (S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IX VOLUMES")]), _vm._v(") O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DHAMS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("HISTORY "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF THE")]), _vm._v(" SECOND WORLD WAR P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URNELL AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(" 1966")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("WORLD WAR II (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WELVE VOLUMES")]), _vm._v(") "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Editor Brigadier Peter Young")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RBIS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHING")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMITED")]), _vm._v(" 1972")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("ILLUSTRIERTE GESCHICHTE "), _c('span', {
    staticClass: "small"
  }, [_vm._v("DES")]), _vm._v(" ZWEITEN WELTTKIEGS")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kurt Zentner")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÜDWEST")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERLAG")]), _vm._v(", M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNCHEN")]), _vm._v(" 1967")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("EIN JAHRHUNDERT UNTER WASSER")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eckard Wetzel")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTORBUCH")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERLAG")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUTTGART")]), _vm._v(" 1916")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("MESSERSCHMITT BF 109 V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROTOTYP")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BIS ZUR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F")]), _vm._v(" 109 K")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Markus Wunderlich")]), _vm._v(" 2017 G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERA")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OND")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERLAG")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MB")]), _vm._v("H, M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÜNCHEN")])]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("WENN ALLE BRÜDER SCHWEIGEN")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSER")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILDBAND ÜBER DIE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AFFEN")]), _vm._v("-SS, M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNIN")]), _vm._v("-V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERLAG ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MB")]), _vm._v("H, O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SNABRUECK")]), _vm._v(" 1985")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("HISTOIRE D’UN MONDE EN GUERRE 39-45")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("under the direction of Claude Quétel")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AROUSSE")]), _vm._v(" 2015")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("HEITAI J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APANESE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NFANTRYMAN")]), _vm._v(" 1931–1945")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Agustín Sáiz")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDREA")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")]), _vm._v(", M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADRID")]), _vm._v(" 2011")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYLOR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHIC")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RCHIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a82de4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Bibliography.vue
// module id = 72
// module chunks = 0